import React from "react";

import MeetingDetails from "./MeetingDetails";

import ActionItemAccordion from "../ChecklistItems/ActionItemAccordion";
import AgendaItemAccordion from "../ChecklistItems/AgendaItemAccordion";
import MeetingNotes from "../Notes/MeetingNotes";

/**
 * The content section of the meeting accordion, extracted for reuse in modals
 * This component expects to be wrapped in a MeetingProvider
 */
const MeetingAccordionContent = () => {
	return (
		<div className="flex h-full min-h-0 flex-1 space-x-4 p-4">
			<div className="flex h-full w-[768px] flex-col space-y-4 overflow-y-auto">
				<MeetingDetails />
				<MeetingNotes />
			</div>
			<div className="flex h-full min-h-0 w-[512px] flex-col space-y-2 overflow-y-auto">
				<AgendaItemAccordion />
				<ActionItemAccordion />
			</div>
		</div>
	);
};

export default MeetingAccordionContent;
